import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/browser";
import "./Assets/Theme.css";

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        release: "publisher-dapp@" + process.env.npm_package_version,
    });
}

const root = createRoot(document.getElementById("root"));
root.render(<App />);
